import "./EmployeeForm.scss";

import React from "react";
import { Link, Redirect } from "react-router-dom";
import request from "request"
import { pick } from "lodash"
import usesFeatures from 'usesFeatures'

import Form from "Form";
import Input from "Input";
import Header from "Header"
import Select from "Select"
import Checkbox from "Checkbox"

class EmployeeForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    const employeeId = this.props.computedMatch.params.employeeId
    if (employeeId) {
      this.props.fetchData(`venue_admin/employees/${employeeId}/edit`, this.props.seedFormData)
    } else {
      this.props.fetchData("venue_admin/employees/new", this.props.seedFormData)
    }
  }

  headerText = () => this.props.formData.id ? `Edit ${this.props.formData.name}` : "New Employee"

  handleSubmit = (e) => {
    e.preventDefault()

    let employee = pick(this.props.formData, [ "name", "storeId", "allTerminals" ])
    const employeeId = this.props.formData.id
    const method = employeeId ? "patch" : "post"
    const url = employeeId ? `employees/${employeeId}` : "employees"

    let req = request[method](`venue_admin/${url}`, { employee: employee })
    req.then(({data}) => {
      if (data.success) {
        this.setState({saved: true})
      } else {
        this.setState({errors: data.errors})
      }
    })
  }

  render() {
    if (!this.props.dataFetched) return false

    const { updateField, formData, stores } = this.props

    if (this.state.saved) return <Redirect to="/employees" />

    const storeOptions = { "": "All Stores" }
    if (stores) {
      stores.forEach(s => {
        storeOptions[s.id] = s.name
      })
    }

    return(
      <div className="EmployeeForm">
        <Header
          text="Employees"
          backLink="/employees"
        />
        <Form className="block" title={this.headerText()} onSubmit={this.handleSubmit}>
          <Input
            label="Employee Name"
            onChange={updateField.bind(null, "name")}
            value={formData.name}
            required
          />
          <Select
            label="Store (Optional)"
            onChange={updateField.bind(null, "storeId")}
            value={formData.storeId || ""}
            options={storeOptions}
          />
          {formData.storeId && (
            <p className="help mb-3">
              Because a store is selected, this employee can only clock in at terminals
              that belong to that store.
            </p>
          )}
          <Checkbox
            label="Available at all terminals"
            value={!!formData.allTerminals}
            onChange={updateField.bind(null, "allTerminals")}
          />
          <p className="help mb-3">
            When off, the employee only appears on the terminal where they clocked in.
            When on, once clocked in they appear on every terminal of their store —
            or, if no store is selected, on every terminal in this venue — and can
            clock out from any of them.
          </p>
          {formData.authCode && (
            <div className="field">
              <label className="label">Auth Code</label>
              <div className="control">
                <span className="tag is-info is-large">{formData.authCode}</span>
                <p className="help">This 4-digit code is auto-generated and unique to this venue.</p>
              </div>
            </div>
          )}
          {this.state.errors && (
            <div className="notification is-danger">
              {this.state.errors.map((error, i) => <div key={i}>{error}</div>)}
            </div>
          )}

          <div className="block field is-grouped">
            <p className="control">
              <button onClick={this.handleSubmit} className="button is-primary">{ formData.id ? "Update" : "Create"} Employee</button>
            </p>
            <p className="control">
              <Link to="/employees" className="button">Cancel</Link>
            </p>
          </div>
        </Form>
      </div>
    )
  }
}
export default usesFeatures(['form', 'data'], EmployeeForm)
